import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  MetadataScraperGetRequest,
  MetadataScraperGetResponse,
} from '../gateway/scraper_pb';

import {
  MetadataScraper as __MetadataScraper,
} from '../gateway/scraper_pb_service';

@Injectable({providedIn: 'root'})
export class MetadataScraper {

  constructor(private _ngZone: NgZone) {
  }

  get(request: MetadataScraperGetRequest): Promise<MetadataScraperGetResponse>;
  get(request: MetadataScraperGetRequest, metadata: grpc.Metadata): Promise<MetadataScraperGetResponse>;
  get(request: MetadataScraperGetRequest, callback: (err: any|null, response: MetadataScraperGetResponse, metadata: grpc.Metadata) => void): void;
  get(request: MetadataScraperGetRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MetadataScraperGetResponse, metadata: grpc.Metadata) => void): void;

  get(request: MetadataScraperGetRequest, arg1?: grpc.Metadata|((err: any|null, response: MetadataScraperGetResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MetadataScraperGetResponse, metadata: grpc.Metadata) => void): Promise<MetadataScraperGetResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MetadataScraperGetResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__MetadataScraper.Get, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

